export const navigateToUrl = (url: string, shouldOpenInNewTab = false) => {
  if (shouldOpenInNewTab) {
    window.open(url, '_blank', 'noopener,noreferrer');
  } else {
    window.location.href = url;
  }
};
